import React from 'react';
import {get, useSelector} from 'helpers';
import {Group, Checkbox, Next} from 'components';
import {store} from 'store';
import questions from './questions.json';
import css from './quiz.module.scss';

const options = [
  { value: '5', label: 'Yes' },
  { value: '4', label: 'Mostly' },
  { value: '3', label: 'Sometimes' },
  { value: '1', label: 'Hardly' },
  { value: '0', label: 'No' },
];

export function Quiz(props) {
  const { quiz, question } = useSelector(state => ({
    ...state.session,
    question: questions[get(props, 'match.params.question')],
  }));

  const save = value => store.dispatch({
    type: 'SESSION_WELCOME_QUIZ',
    quiz: {
      ['quiz-'+question.name]: value
    }
  });

  return (
    <div>
      <p>{ question.description }</p>
      <Group className={css('radio-group', 'small-spacing')}>
        { options.map(({ value, label }) =>
          <Checkbox.Container
            className="has-background"
            radio
            onClick={() => save(value)}
            checked={quiz['quiz-'+question.name] === value}
            key={value}
            children={label}
          />
        ) }
      </Group>
      <p className="medium-spacing text-center">
        <Next />
      </p>
    </div>
  );
}
